<template>
  <section class="hero-section">
    <v-container>
      <v-row align="center" class="hero-row">
        <!-- Left Column - Text Content -->
        <v-col cols="12" md="6" class="hero-content animate-block">
          <h1 class="hero-title">
            {{ $t('hero.titlePart1') }}<span class="highlight">{{ $t('hero.titleHighlight') }}</span>{{ $t('hero.titlePart2') }}
          </h1>

          <p class="hero-subtitle">{{ $t('hero.subtitle') }}</p>

          <div class="hero-buttons">
            <button class="insurance-btn" @click="scrollToServices">
              <span>{{ $t('hero.btnInsurance') }}</span>
              <svg width="17" height="17" viewBox="0 0 17 17" fill="none">
                <path d="M6.5 4.5L10.5 8.5L6.5 12.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </button>
            <button class="contact-btn" @click="openContact">{{ $t('hero.btnContact') }}</button>
          </div>
        </v-col>

        <!-- Right Column - Image -->
        <v-col cols="12" md="6" class="hero-image-col">
          <img src="../assets/images/1.webp" alt="Your insurance, our responsibility" class="hero-image" />
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import { eventBus } from '@/eventBus'
import { animateOnScroll } from '@/mixins/animateOnScroll'

export default {
  name: 'HeroSection',
  mixins: [animateOnScroll],
  methods: {
    openContact() {
      eventBus.showContactModal = true
    },
    scrollToServices() {
      document.getElementById('services').scrollIntoView({ behavior: 'smooth' })
    }
  }
}
</script>

<style scoped>
.hero-section {
  background: #ededed;
  overflow: hidden;
}

.hero-row {
  min-height: 600px;
}

.hero-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
}

.hero-title {
  font-family: "SF Pro", "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 40px;
  font-weight: 500;
  line-height: 48.8px;
  letter-spacing: -0.02em;
  color: rgb(46, 46, 46);
  margin: 0;
  max-width: 577px;
}

.hero-title .highlight {
  color: rgb(18, 129, 149);
}

.hero-subtitle {
  font-family: "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.01em;
  color: rgb(103, 103, 103);
  margin: 0;
}

.hero-buttons {
  display: flex;
  gap: 5px;
}

.insurance-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 141px;
  height: 38px;
  background: #1CA5BE;
  color: rgb(241, 241, 241);
  border: none;
  border-radius: 4px;
  font-family: "SF Pro", "SF Pro Display", sans-serif;
  font-size: 11px;
  font-weight: 400;
  letter-spacing: -0.03em;
  line-height: 16.8px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.insurance-btn:hover {
  background: rgb(18, 129, 149);
}

.insurance-btn svg {
  width: 17px;
  height: 17px;
}

.contact-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 141px;
  height: 38px;
  background: #2e2e2e;
  color: rgb(241, 241, 241);
  border: none;
  border-radius: 4px;
  font-family: "SF Pro", "SF Pro Display", sans-serif;
  font-size: 11px;
  font-weight: 400;
  letter-spacing: -0.03em;
  line-height: 16.8px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.contact-btn:hover {
  background: #1a1a1a;
}

.hero-image-col {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.hero-image {
  width: 100%;
  height: auto;
  aspect-ratio: 625 / 552;
  object-fit: cover;
  object-position: center;
  display: block;
}

/* Responsive */
@media (max-width: 1280px) {
  .hero-title {
    font-size: 36px;
    line-height: 44px;
  }
}

@media (max-width: 960px) {
  .hero-row {
    min-height: auto;
    padding: 0;
  }

  .hero-row :deep(.v-col) {
    padding: 0;
  }

  .hero-image-col {
    order: -1;
  }

  .hero-image {
    width: 100%;
    aspect-ratio: auto;
  }

  .hero-content {
    padding: 32px 16px;
    gap: 16px;
  }

  .hero-title {
    font-size: 28px;
    line-height: 36px;
  }

  .hero-subtitle {
    font-size: 14px;
  }

}

@media (max-width: 600px) {
  .hero-title {
    font-size: 26px;
    line-height: 34px;
  }
}
</style>
